.xnarrow {
  max-width: 24rem;
}

.smallest {
  max-width: 17rem;
  max-height: 17rem;
}
